import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorChallengeUserLessonNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IChallengeUserLessonModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IChallengeUserLessonFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useChallengeUserLessonHookNae(id: number) : IChallengeUserLessonModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorChallengeUserLessonNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "challenge-user-lesson",
        fields: IChallengeUserLessonFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
